module.exports = __webpack_public_path__ + "img/bolt-auto.424825d7.svg";